import { RichText } from 'components/rich-text/RichText'
import { PowerPackageType } from 'pages/api/get-power-packages'

import styles from './Card.module.scss'

import { PrismicImage } from '@prismicio/react'
import { useAnimationControls } from 'framer-motion'
import { useState } from 'react'
import FakeButton from 'components/new-buttons/FakeButton'
import cx from 'classnames'
import {
  formatPricesOnPackages,
  hasPackageTwoPrices,
} from 'utils/powerPackageHelper'
import { powerPackageDataUnit } from 'components/prices/PricesOfPackagesList'

interface PowerPackageCardProps {
  item: PowerPackageType
  onCardSelection: (uid: string) => void
  isSelected: boolean
}

const Card = (props: PowerPackageCardProps) => {
  const { item, onCardSelection, isSelected } = props
  const animationControls = useAnimationControls()
  const [hover, setHover] = useState<boolean>(false)

  const shouldBeStrikedThrough = hasPackageTwoPrices(item.first_price_title)

  return (
    <button
      className={cx(styles.card, {
        [styles.greenBorder]: isSelected,
      })}
      onClick={() =>
        onCardSelection(isSelected ? '' : item._meta.uid.split('_')[0])
      }
      onMouseEnter={() => {
        animationControls.start('hover')
        setHover(true)
      }}
      onMouseLeave={() => {
        animationControls.start('initial')
        setHover(false)
      }}
    >
      <div className={styles.topWrapper}>
        <PrismicImage
          field={item.package_image}
          className={styles.packageImage}
        />
        <h3 className={styles.packageName}>{item.package_name}</h3>
      </div>
      {isSelected && <div className={styles.greenBanner}>Valið</div>}

      <div className={styles.contentWrapper}>
        <RichText className={styles.description}>{item.description}</RichText>
      </div>

      <div className={styles.bottomWrapper}>
        <div className={styles.priceWrapper}>
          <span
            className={
              shouldBeStrikedThrough
                ? styles.firstPriceName
                : styles.secondPriceName
            }
          >
            {item.first_price_title}
          </span>
          <span
            className={
              shouldBeStrikedThrough
                ? styles.firstPriceValue
                : styles.secondPriceValue
            }
          >
            {formatPricesOnPackages(item.package_first_price)}{' '}
            {powerPackageDataUnit}
          </span>
          <span className={styles.secondPriceName}>
            {item.second_price_title}
          </span>
          <span className={styles.secondPriceValue}>
            {formatPricesOnPackages(item.package_second_price)}{' '}
            {powerPackageDataUnit}
          </span>
        </div>
        <FakeButton
          animationControls={animationControls}
          isHoverOnCard={hover}
          isLightningButton={true}
          titleOnButton={isSelected ? 'Afvelja' : 'Velja'}
        />
      </div>
    </button>
  )
}
export default Card
